import styles from "./NavTopBarVerticalDivider.module.scss"

export default function NavTopBarVerticalDivider() {
    return <div className={styles.base}>/</div>
}
